
import AutoLayerStoryLeaderboardList from './AutoLayerStoryLeaderboardList';
import AutoLayerStoryLeaderboardTable from './AutoLayerStoryLeaderboardTable';

const AutoLayerStoryLeaderboard = () => {
  return (
    <>
      <AutoLayerStoryLeaderboardTable className="max-lg:hidden" />
      <AutoLayerStoryLeaderboardList className="lg:hidden" />
    </>
  );
};

export default AutoLayerStoryLeaderboard;
